export const getIndividualSquad = (Id = undefined) => {
  if (!Id) {
    return null;
  }

  return `
          SELECT
            Id,
            Name,
            OwnerId
          FROM
            Mesa__c
          WHERE
            Id = '${Id}'
          LIMIT 1
        `;
};
